module.exports = __webpack_public_path__ + "img/item(15).89e67c2c.svg";